import { render, staticRenderFns } from "./DiscoveryTemplateCard.vue?vue&type=template&id=033fe0db&scoped=true&"
import script from "./DiscoveryTemplateCard.vue?vue&type=script&lang=js&"
export * from "./DiscoveryTemplateCard.vue?vue&type=script&lang=js&"
import style0 from "./DiscoveryTemplateCard.vue?vue&type=style&index=0&id=033fe0db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033fe0db",
  null
  
)

export default component.exports